export function validateField(state, action) {
  let fields = state.fields.map((item) => {
    if (item.name === action.field.name) {
      return action.field;
    } else {
      return item;
    }
  });

  let valid = fields.filter((field) => field.errors.length > 0).length > 0 ? false : true;

  return Object.assign({}, state, {
    valid: true,
    fields: Array.from(fields),
  });
}

export function clearFields(state) {
  let fields = state.fields.map((item) => {
    if (item.type == "checkbox") {
      return Object.assign({}, item, {
        value: false,
        errors: [],
      });
    }
    if (item.type == "select") {
      return Object.assign({}, item, {
        value: false,
        defaultValue: false,
        errors: [],
      });
    } else {
      return Object.assign({}, item, {
        value: "",
        errors: [],
      });
    }
  });

  return Object.assign({}, state, {
    valid: false,
    fields: Array.from(fields),
  });
}

export function clearField(state, fieldName) {
  let fields = state.fields.map((item) => {
    if (item.name === fieldName) {
      return Object.assign({}, item, {
        value: "",
        errors: [],
      });
    } else {
      return item;
    }
  });

  return Object.assign({}, state, {
    valid: false,
    fields: Array.from(fields),
  });
}

export function submitFields(state, action) {
  let valid = action.fields.filter((field) => field.errors.length > 0).length > 0 ? false : true;

  return Object.assign({}, state, {
    valid: valid,
    fields: Array.from(action.fields),
  });
}

export function setFieldOptions(state, fieldName, optionsAndSelectedValue, filteredOptions) {
  let fields = state.fields.map((item) => {
    if (item.name === fieldName) {
      let selectedValue = optionsAndSelectedValue.SelectedValue;
      if (!IsOnTheList(optionsAndSelectedValue.Items, selectedValue)) {
        selectedValue = "";
      }

      let newItem = Object.assign({}, item, {
        options: optionsAndSelectedValue.Items,
        value: selectedValue,
      });

      if (filteredOptions) {
        newItem = Object.assign({}, newItem, {
          filteredOptions: filteredOptions,
        });
      }
      return newItem;
    } else {
      return item;
    }
  });
  return Object.assign({}, state, {
    fields: Array.from(fields),
  });
}
export function setCheckBoxValue(state, fieldName, selectedValue) {
  let fields = state.fields.map((item) => {
    if (item) {
      if (item.name === fieldName) {
        let newItem = Object.assign({}, item, {
          value: selectedValue,
          errors: []
        });
        return newItem;
      } else {
        return item;
      }
    }
  });

  return Object.assign({}, state, {
    fields: Array.from(fields),
  });
}

export function setTeaxtareaValue(state, fieldName, selectedValue) {
  let fields = state.fields.map((item) => {
    if (item) {
      if (item.name === fieldName) {
        let newItem = Object.assign({}, item, {
          value: selectedValue,
          errors: []
        });
        return newItem;
      } else {
        return item;
      }
    }
  });

  return Object.assign({}, state, {
    fields: Array.from(fields),
  });
}



export function setFieldRequired(item, isRequired) {
  if (isRequired) {
    return Object.assign({}, item, {
      rules: {
        title: item.rules.title,
        required: true,
      },
      errors: [],
    });
  } else {
    return Object.assign({}, item, {
      rules: {
        title: item.rules.title,
      },
      errors: [],
    });
  }
}

//verify if selected value exists on the items list
function IsOnTheList(items, selectedValue) {
  if (!selectedValue) {
    return false;
  }

  var exist = false;

  selectedValue.split(",").forEach((value) => {
    exist = items.some((item) => {
      //PB-1195 - Perform loose comparrision instead strict one with ===, should work for all data types
      // eslint-disable-next-line eqeqeq
      return item.value == value;
    });

    if (!exist) {
      // break the loop
      return false;
    }
  });

  return exist;
}

//selected value to string
/* function isStringNumber(selectedValue) {
  if (!selectedValue) {
    return false;
  }

  let number = parseInt(selectedValue);
  if (!isNaN(number)) {
    return number;
  }
  return selectedValue;
} */
